<i18n src="./langset.json"></i18n>
<template>
  <div class="min-h-screen flex bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 relative">
    <!-- 左侧品牌信息区域 -->
    <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden">
      <div class="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-purple-600/20"></div>
      
      <!-- 增强的科技风格背景图案 -->
      <div class="absolute inset-0">
        <!-- 大型几何图形 -->
        <div class="absolute top-10 left-10 w-64 h-64 border-2 border-blue-400/30 rounded-full animate-pulse"></div>
        <div class="absolute top-10 left-10 w-64 h-64 border-4 border-blue-400/20 rounded-full animate-ping" style="animation-duration: '3s'"></div>
        
        <div class="absolute bottom-20 right-20 w-96 h-96 border-2 border-purple-400/30 rounded-full animate-pulse"></div>
        <div class="absolute bottom-20 right-20 w-96 h-96 border-4 border-purple-400/20 rounded-full animate-ping" style="animation-duration: '4s'"></div>
        
        <div class="absolute top-1/2 left-1/3 w-48 h-48 border-2 border-cyan-400/30 rounded-lg transform rotate-45 animate-pulse"></div>
        <div class="absolute top-1/2 left-1/3 w-48 h-48 border-4 border-cyan-400/20 rounded-lg transform rotate-45 animate-ping" style="animation-duration: '3.5s'"></div>
        
        <div class="absolute bottom-1/3 right-1/4 w-32 h-32 border-2 border-blue-400/30 rounded-lg transform rotate-12 animate-pulse"></div>
        <div class="absolute bottom-1/3 right-1/4 w-32 h-32 border-4 border-blue-400/20 rounded-lg transform rotate-12 animate-ping" style="animation-duration: '2.5s'"></div>

        <!-- 额外的大型几何图形 -->
        <div class="absolute top-1/4 right-1/3 w-80 h-80 border-2 border-indigo-400/20 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/4 left-1/4 w-72 h-72 border-2 border-teal-400/20 rounded-lg transform rotate-12 animate-pulse"></div>
        <div class="absolute top-2/3 left-1/2 w-56 h-56 border-2 border-pink-400/20 rounded-full animate-pulse"></div>

        <!-- 光晕效果 -->
        <div class="absolute top-10 left-10 w-64 h-64 bg-blue-400/10 rounded-full blur-3xl animate-pulse"></div>
        <div class="absolute bottom-20 right-20 w-96 h-96 bg-purple-400/10 rounded-full blur-3xl animate-pulse" style="animation-duration: '4s'"></div>
        <div class="absolute top-1/2 left-1/3 w-48 h-48 bg-cyan-400/10 rounded-lg blur-3xl transform rotate-45 animate-pulse" style="animation-duration: '3.5s'"></div>
        <div class="absolute top-1/4 right-1/3 w-80 h-80 bg-indigo-400/8 rounded-full blur-3xl animate-pulse" style="animation-duration: '5s'"></div>
        <div class="absolute bottom-1/4 left-1/4 w-72 h-72 bg-teal-400/8 rounded-lg blur-3xl transform rotate-12 animate-pulse" style="animation-duration: '4.5s'"></div>
        <div class="absolute top-2/3 left-1/2 w-56 h-56 bg-pink-400/8 rounded-full blur-3xl animate-pulse" style="animation-duration: '3.8s'"></div>

        <!-- {/* 浮动粒子效果 */} -->
        <div class="absolute top-20 left-20 w-2 h-2 bg-blue-400/60 rounded-full"></div>
        <div class="absolute top-40 left-60 w-3 h-3 bg-cyan-400/50 rounded-full"></div>
        <div class="absolute top-60 left-40 w-2 h-2 bg-purple-400/60 rounded-full"></div>
        <div class="absolute top-80 left-80 w-1 h-1 bg-indigo-400/70 rounded-full"></div>
        <div class="absolute top-32 left-120 w-2 h-2 bg-teal-400/50 rounded-full"></div>
        <div class="absolute top-72 left-100 w-3 h-3 bg-pink-400/40 rounded-full"></div>
        <div class="absolute top-16 left-160 w-1 h-1 bg-blue-400/80 rounded-full"></div>
        <div class="absolute top-48 left-140 w-2 h-2 bg-cyan-400/60 rounded-full"></div>
        
        <div class="absolute bottom-40 right-60 w-2 h-2 bg-purple-400/60 rounded-full"></div>
        <div class="absolute bottom-60 right-40 w-3 h-3 bg-indigo-400/50 rounded-full"></div>
        <div class="absolute bottom-80 right-80 w-1 h-1 bg-teal-400/70 rounded-full"></div>
        <div class="absolute bottom-32 right-120 w-2 h-2 bg-pink-400/50 rounded-full"></div>
        <div class="absolute bottom-72 right-100 w-3 h-3 bg-blue-400/40 rounded-full"></div>
        <div class="absolute bottom-16 right-160 w-1 h-1 bg-cyan-400/80 rounded-full"></div>
        <div class="absolute bottom-48 right-140 w-2 h-2 bg-purple-400/60 rounded-full"></div>
        <div class="absolute bottom-20 right-180 w-1 h-1 bg-indigo-400/70 rounded-full"></div>

        <!-- {/* 电路节点和连线 */} -->
        <svg class="absolute inset-0 w-full h-full">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" stroke-width="1" opacity="0.1"/>
            </pattern>
            
            <!-- {/* 发光效果滤镜 */} -->
            <filter id="glow">
              <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          <!-- {/* 网格背景 */} -->
          <rect width="100%" height="100%" fill="url(#grid)" />
          
          <!-- {/* 电路连线 */} -->
          <g class="circuit-lines">
            <line x1="100" y1="100" x2="200" y2="150" stroke="cyan" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="200" y1="150" x2="300" y2="100" stroke="blue" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="300" y1="100" x2="400" y2="200" stroke="purple" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="400" y1="200" x2="350" y2="300" stroke="indigo" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="350" y1="300" x2="250" y2="350" stroke="teal" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="250" y1="350" x2="150" y2="300" stroke="pink" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="150" y1="300" x2="100" y2="200" stroke="cyan" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            <line x1="100" y1="200" x2="100" y2="100" stroke="blue" stroke-width="2" opacity="0.3" class="animate-pulse"/>
            
            <!-- {/* 更多电路连线 */} -->
            <line x1="500" y1="50" x2="600" y2="100" stroke="cyan" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="600" y1="100" x2="650" y2="200" stroke="blue" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="650" y1="200" x2="550" y2="250" stroke="purple" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="550" y1="250" x2="450" y2="200" stroke="indigo" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="450" y1="200" x2="500" y2="100" stroke="teal" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="500" y1="100" x2="500" y2="50" stroke="pink" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            
            <line x1="50" y1="400" x2="150" y2="450" stroke="cyan" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="150" y1="450" x2="250" y2="400" stroke="blue" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="250" y1="400" x2="300" y2="500" stroke="purple" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="300" y1="500" x2="200" y2="550" stroke="indigo" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="200" y1="550" x2="100" y2="500" stroke="teal" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
            <line x1="100" y1="500" x2="50" y2="400" stroke="pink" stroke-width="1.5" opacity="0.25" class="animate-pulse"/>
          </g>
          
          <g class="circuit-nodes">
            <circle cx="100" cy="100" r="6" fill="cyan" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="200" cy="150" r="6" fill="blue" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="300" cy="100" r="6" fill="purple" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="400" cy="200" r="6" fill="indigo" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="350" cy="300" r="6" fill="teal" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="250" cy="350" r="6" fill="pink" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="150" cy="300" r="6" fill="cyan" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="100" cy="200" r="6" fill="blue" filter="url(#glow)" class="animate-pulse"/>
            
            <!-- {/* 额外节点 */} -->
            <circle cx="500" cy="50" r="5" fill="cyan" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="600" cy="100" r="5" fill="blue" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="650" cy="200" r="5" fill="purple" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="550" cy="250" r="5" fill="indigo" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="450" cy="200" r="5" fill="teal" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="500" cy="100" r="5" fill="pink" filter="url(#glow)" class="animate-pulse"/>
            
            <circle cx="50" cy="400" r="5" fill="cyan" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="150" cy="450" r="5" fill="blue" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="250" cy="400" r="5" fill="purple" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="300" cy="500" r="5" fill="indigo" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="200" cy="550" r="5" fill="teal" filter="url(#glow)" class="animate-pulse"/>
            <circle cx="100" cy="500" r="5" fill="pink" filter="url(#glow)" class="animate-pulse"/>
          </g>
        </svg>
      </div>

      <div class="relative z-10 flex flex-col justify-center px-12 text-white" style="width:80%;align-items: center;">
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-6">
            <el-icon class="w-10 h-10 text-blue-400" size="32" color="#409eff"><OfficeBuilding /></el-icon>
            <h1 class="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              企业SaaS Pro
            </h1>
          </div>
          <h2 class="text-2xl font-semibold mb-4">企业级数字化管理平台</h2>
          <p class="text-lg text-blue-200 mb-2">高效、安全、智能</p>
        </div>

        <div class="space-y-6 mt-12">
          <div class="flex items-center gap-4">
            <div class="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
              <el-icon class="w-6 h-6 text-blue-400"  size="24" color="#409eff"><Lock /></el-icon>
            </div>
            <div>
              <h3 class="font-semibold text-lg">安全可靠</h3>
              <p class="text-blue-200">企业级安全保障，数据加密传输</p>
            </div>
          </div>

          <div class="flex items-center gap-4">
            <div class="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center">
              <el-icon class="w-6 h-6 text-purple-400" size="24" color="#9f7aea"><User /></el-icon>
            </div>
            <div>
              <h3 class="font-semibold text-lg">多租户架构</h3>
              <p class="text-blue-200">支持多企业独立管理，数据隔离</p>
            </div>
          </div>

          <div class="flex items-center gap-4">
            <div class="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center">
              <el-icon class="w-6 h-6 text-cyan-400" size="24" color="#22d3ee "><DataLine /></el-icon>
            </div>
            <div>
              <h3 class="font-semibold text-lg">智能分析</h3>
              <p class="text-blue-200">数据驱动决策，业务洞察一目了然</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-1/2 flex items-center justify-center p-8">
      <language-switcher
        class="lang-style"
        @lang-change="langChangeFn"
      ></language-switcher>
      <el-card class="w-full max-w-md bg-white/95 backdrop-blur-sm shadow-2xl border-0" style="border-radius:15px;">
        <sliderCaptcha
          v-if="silderFlag"
          @success="handleLogin"
          style="position: absolute; z-index: 99; top: 50px"
          @fail="handleFail"
        ></sliderCaptcha>
        <div class="p-8">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-900 mb-2">欢迎回来</h2>
            <p class="text-gray-600">请输入您的账号密码登录系统</p>
          </div>

         <el-form
          :model="loginFormUser"
          class="login-form"
          label-position="top"
          @submit.prevent="silderFlag = true"
        >
          <el-form-item label="用户名" prop="username">
            <el-input
              v-model.trim="loginFormUser.username"
              placeholder="请输入用户名"
              ref="usernameRef"
              prefix-icon="User"
              clearable
              size="large"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码"  prop="password">
            <el-input
              v-model.trim="loginFormUser.password"
              type="password"
              autocomplete="new-password"
              clearable
              placeholder="请输入密码"
              prefix-icon="Lock"
              size="large"
              show-password
            ></el-input>
          </el-form-item>
          <div>
            <span>
              <el-checkbox
                v-model="rememberPassword"
                :label="t('记住账号密码')"
                size="large"
              />
            </span>
          </div>
          <el-button
            type="primary"
            size="large"
            class="login-btn"
            :loading="loading"
            native-type="submit"
            :disabled="
              !(
                loginFormUser.username &&
                loginFormUser.password 
              )
            "
          >
            {{ t("登录") }}
          </el-button>
        </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>


<script lang="ts" setup>
import sliderCaptcha from "./sliderCaptcha.vue";
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { 
 User,
 DataLine,
  OfficeBuilding,
  Lock,
  View,
  Hide
} from '@element-plus/icons-vue'
import LanguageSwitcher from "@/components/languageSwitcher/index.vue";
import { setTenant, setToken, setRenewToken } from "@/utils/auth.ts";
import request from "@/utils/request";
import API_CONFIG from "./api.json";
import { useI18n } from "vue-i18n";
import { getAllDictData } from "@/utils/index.ts";
import {
  getAccountInfo,
  setAccountInfo,
  removeAccountInfo,
} from "@/utils/rememberAccount.ts";
import { sha512Encrypt } from "@/utils/crypto.ts";

const handleFail = () => {};
const usernameRef = ref(null);
const langChangeFn = () => {
  usernameRef.value?.focus();
  silderFlag.value = false;
};
onMounted(() => {
  langChangeFn();
  const accountInfo = getAccountInfo();
  if (accountInfo) {
    const data = JSON.parse(accountInfo);
    loginFormUser.username = data.loginName || "";
    loginFormUser.password = data.password || "";
  }
});

const { t } = useI18n();
const silderFlag = ref(false);
const router = useRouter();
const loginFormUser = reactive({
  username: "",
  password: "",
});

const loading = ref(false);
const rememberPassword = ref(true);

function getGreeting() {
  const hour = new Date().getHours();
  const greetings = {
    morning: [
      `☀️ ${t("morning1")}`,
      `🌿 ${t("morning2")} `,
      `📝 ${t("morning3")} `,
      `🚀 ${t("morning4")} `,
    ],
    noon: [
      `🕛 ${t("noon1")}`,
      `⏳ ${t("noon2")}`,
      `🌞 ${t("noon3")}`,
      `📌 ${t("noon4")}`,
    ],
    afternoon: [
      `⏰ ${t("afternoon1")}`,
      `🌤️ ${t("afternoon2")}`,
      `🎯 ${t("afternoon3")}`,
      `🧘 ${t("afternoon4")}`,
    ],
    evening: [
      `🌙 ${t("evening1")}`,
      `📚 ${t("evening2")}`,
      `🏃 ${t("evening3")}`,
      `🎨 ${t("evening4")}`,
    ],
    night: [
      `🌌 ${t("night1")}`,
      `🛋️ ${t("night2")}`,
      `💡 ${t("night3")}`,
      `📖 ${t("night4")}`,
    ],
  };

  // 时间判断逻辑保持不变
  if (hour >= 5 && hour < 11) {
    return greetings.morning[Math.floor(Math.random() * 4)];
  } else if (hour >= 11 && hour < 14) {
    return greetings.noon[Math.floor(Math.random() * 4)];
  } else if (hour >= 14 && hour < 18) {
    return greetings.afternoon[Math.floor(Math.random() * 4)];
  } else if (hour >= 18 && hour < 22) {
    return greetings.evening[Math.floor(Math.random() * 4)];
  } else {
    return greetings.night[Math.floor(Math.random() * 4)];
  }
}

const handleLogin = () => {
  loading.value = true;
  const params = {
    loginName: loginFormUser.username,
    password: sha512Encrypt(loginFormUser.password),
    encodeType: 'encode'
  };
  request
    .post(API_CONFIG.loginUrl.url, params)
    .then((res: Record<string, any>) => {
      if (res?.code == 200) {
        setToken(res.data[0]);
        setRenewToken(res.data[1]);
        setTenant(res.data[res.data.length-1]);
        getAllDictData();
        setTimeout(() => {
          ElMessage.success(getGreeting());
          router.push("/_blank");
        }, 100);
      } else {
        ElMessage.error(res.data.msg);
      }
    })
    .finally(() => {
      loading.value = false;
      silderFlag.value = false;
    })
    .finally(() => {
      rememberAccount(rememberPassword.value);
    });
};

// 记住密码
const rememberAccount = (value) => {
  if (value) {
    setAccountInfo(
      JSON.stringify({
        loginName: loginFormUser.username,
        password: loginFormUser.password
      })
    );
  } else {
    removeAccountInfo();
  }
};
</script>

<style scoped>
.login-btn {
  width: 100%;
}
.lang-style{
  position: fixed;
  top: 15px;
  right: 10px;
}
/* 自定义动画和样式 */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-ping {
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes ping {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0;
  }
}
</style>
